import { render, staticRenderFns } from "./BookingVideoRoom.vue?vue&type=template&id=6e787716&scoped=true"
import script from "./BookingVideoRoom.vue?vue&type=script&lang=js"
export * from "./BookingVideoRoom.vue?vue&type=script&lang=js"
import style0 from "./BookingVideoRoom.vue?vue&type=style&index=0&id=6e787716&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e787716",
  null
  
)

export default component.exports